var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "forceCloseFormRef",
          attrs: { model: _vm.forceCloseFormData, "label-position": "top" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("mdfeTranslate.InvoiceSecretKey"),
                        prop: "mdfeKey",
                        rules: {
                          required: true,
                          validator: _vm.enterNumber,
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                        },
                        model: {
                          value: _vm.forceCloseFormData.mdfeKey,
                          callback: function ($$v) {
                            _vm.$set(_vm.forceCloseFormData, "mdfeKey", $$v)
                          },
                          expression: "forceCloseFormData.mdfeKey",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("mdfeTranslate.AgreementNumber"),
                        prop: "protocolNumber",
                        rules: {
                          required: true,
                          validator: _vm.enterNumber,
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                        },
                        model: {
                          value: _vm.forceCloseFormData.protocolNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.forceCloseFormData,
                              "protocolNumber",
                              $$v
                            )
                          },
                          expression: "forceCloseFormData.protocolNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("mdfeTranslate.CompanyTaxNumber"),
                        prop: "cnpj",
                        rules: {
                          required: true,
                          message: _vm.$t("placeOrder.pleaseChoose"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "formTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("placeOrder.pleaseChoose"),
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            "remote-method": _vm.getCompanyList,
                          },
                          on: { "visible-change": _vm.handleCompanyList },
                          model: {
                            value: _vm.forceCloseFormData.cnpj,
                            callback: function ($$v) {
                              _vm.$set(_vm.forceCloseFormData, "cnpj", $$v)
                            },
                            expression: "forceCloseFormData.cnpj",
                          },
                        },
                        _vm._l(_vm.companyList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.fantasyName
                                ? item.fantasyName
                                : item.name,
                              value: item.cnpj,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("mdfeTranslate.EndState"),
                        prop: "endUfCode",
                        rules: {
                          required: true,
                          message: _vm.$t("placeOrder.pleaseChoose"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("placeOrder.pleaseChoose"),
                            clearable: "",
                            filterable: "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.getMidProvinceChange(
                                _vm.forceCloseFormData.endUfCode
                              )
                            },
                          },
                          model: {
                            value: _vm.forceCloseFormData.endUfCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.forceCloseFormData, "endUfCode", $$v)
                            },
                            expression: "forceCloseFormData.endUfCode",
                          },
                        },
                        _vm._l(_vm.senderStateList, function (list) {
                          return _c("el-option", {
                            key: list.stateCode,
                            attrs: {
                              label:
                                list.stateNameZh +
                                "（" +
                                list.stateNamePu +
                                "）",
                              value: list.stateCodeNumber,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("mdfeTranslate.EndCity"),
                        prop: "endCityCode",
                        rules: {
                          required: true,
                          message: _vm.$t("placeOrder.pleaseChoose"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("placeOrder.pleaseChoose"),
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.forceCloseFormData.endCityCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.forceCloseFormData,
                                "endCityCode",
                                $$v
                              )
                            },
                            expression: "forceCloseFormData.endCityCode",
                          },
                        },
                        _vm._l(_vm.senderCityList, function (list) {
                          return _c("el-option", {
                            key: list.cityCodeNumber,
                            attrs: {
                              label:
                                list.cityNameZh + "（" + list.cityNamePu + "）",
                              value: list.cityCodeNumber,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }